export const ALL_OPTIONS = 'all-options';

export default {
  ALL_OPTIONS,
};
